module.exports = __webpack_public_path__ + "img/Weapon_69.8d643529.png";